import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'

function getErrorMessage(error) {
  if (typeof error === 'string' && error.trim()) return error
  if (error instanceof Error && error.message.trim()) return error.message
  if (error && typeof error === 'object' && typeof error.message === 'string' && error.message.trim()) return error.message
  return '操作失败，请稍后重试'
}

const modal = {
  success(message) { ElMessage.success(message) },
  error(error) { ElMessage.error(getErrorMessage(error)) },
  warning(message) { ElMessage.warning(message) },
  info(message) { ElMessage.info(message) },
  confirm(message, title = '提示') { return ElMessageBox.confirm(message, title, { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }) },
  prompt(message, title = '提示', options = {}) { return ElMessageBox.prompt(message, title, { confirmButtonText: '确定', cancelButtonText: '取消', inputType: 'textarea', inputPattern: /[\s\S]+/, inputErrorMessage: '请填写撤销原因', ...options }) },
  loading(text = '处理中...') { return ElLoading.service({ text, background: 'rgba(22, 55, 53, 0.25)' }) }
}

export default modal
